import { Tooltip } from "antd";
import { ComponentType } from "../types";
import FargateLogo from "../assets/fargate.png";
import KubernetesLogo from "../assets/kubernetes-icon.svg";


const ComponentIcon = (props: { type: ComponentType, size?: "xs" | "small" | "large" }) => {
    const getIconSize = () => {
        if (props.size === "large") return { fontSize: "35px", width: "40px" };
        if (props.size === "xs") return { fontSize: "16px", width: "18px" };
        return { fontSize: "22px", width: "25px" };
    };

    const sizes = getIconSize();

    switch (props.type) {
        case "kubernetes":
        case "k8s":
            return <Tooltip title="Kubernetes">
                <img
                    src={KubernetesLogo}
                    style={{
                        width: props.size === "small" ? "18px" : props.size === "xs" ? "14px" : sizes.width
                    }}
                    alt="kubernetes"
                />
            </Tooltip>
        case "fargate":
        case "ecs":
            return <Tooltip title="AWS Fargate - Serverless compute">
                <img
                    src={FargateLogo}
                    style={{
                        width: sizes.width
                    }}
                    alt="fargate"
                />
            </Tooltip>
        default:
            return undefined;

    }
}

export default ComponentIcon;